module.exports = __webpack_public_path__ + "img/239.compressor_drainage.184e5bf0.svg";